import React from "react";

const WebPages_Security = () => {
  return (
    <div className="tutorial-page">
      <h1>WebPages Security</h1>
      <p>This is the WebPages Security page content.</p>
    </div>
  );
};

export default WebPages_Security;
